<div class="row" *ngIf="isComercial || isBasica">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>

                <mat-card-content *ngIf="!collapseCard">
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Peso Bruto {{hintKg}}</mat-label>
                                <input matInput id="txtPesoBruto" #txtPesoBruto maxlength="20" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 0 }"
                                    (blur)="calcPesoLiquido()" (blur)="tonLaneHr()" formControlName="Peso_bruto">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-hint align="end">{{txtPesoBruto.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Peso_bruto)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Peso Tara {{hintKg}}</mat-label>
                                <input matInput id="txtPesoTara" #txtPesoTara maxlength="20" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 0 }"
                                    (blur)="calcPesoLiquido()" (blur)="tonLaneHr(); validatePesoBrutoETara()"
                                    formControlName="Peso_tara">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-hint align="end">{{txtPesoTara.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Peso_tara)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Peso Líquido {{hintKg}}</mat-label>
                                <input matInput id="txtPesoLiquido" #txtPesoLiquido maxlength="20" readonly
                                    formControlName="Peso_liquido" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 0 }" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                                </mat-hint>
                                <mat-hint align="end">{{txtPesoLiquido.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Peso_liquido)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Início Descarga Data</mat-label>
                                <input matInput id="txtIniDescargaData" #txtIniDescargaData maxlength="10"
                                    mask="d0/M0/0000" formControlName="Inicio_descarga_data"
                                    [dropSpecialCharacters]="false" (blur)="makeCalculations()" (blur)="tonLaneHr()"
                                    (blur)="alertaData()">

                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintDate}}
                                </mat-hint>
                                <mat-hint align="end">{{txtIniDescargaData.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Inicio_descarga_data)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Início Descarga Hora</mat-label>
                                <input matInput id="txtIniDescargaHora" #txtIniDescargaHora maxlength="5" mask="Hh:m0"
                                    [dropSpecialCharacters]="false" formControlName="Inicio_descarga_hora"
                                    (blur)="makeCalculations()" (blur)="tonLaneHr()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintHour}}
                                </mat-hint>
                                <mat-hint align="end">{{txtIniDescargaHora.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Inicio_descarga_hora)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Tempo Espera Pátio {{hintHourResult}}</mat-label>
                                <input matInput id="txtPatio" #txtPatio maxlength="5" readonly
                                    formControlName="Tempo_espera_patio" (blur)="makeCalculationsII()" currencyMask
                                    class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                                </mat-hint>
                                <mat-hint align="end">{{txtPatio.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Tempo_espera_patio)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Tempo Total de Transporte {{hintHourResult}}
                                </mat-label>
                                <input matInput id="txtTransporte" #txtTransporte maxlength="5" readonly
                                    formControlName="Tempo_total_transporte" (blur)="makeCalculationsII()" currencyMask
                                    class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                                </mat-hint>
                                <mat-hint align="end">{{txtTransporte.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Tempo_total_transporte)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">A carga teve transbordo?</mat-label>
                                <mat-select formControlName="Carga_transbordo"
                                    (selectionChange)="changeCargaTransbordo($event)">
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterCargaTransbordo($event.target.value)">
                                    <mat-option *ngFor="let item of listCargaTransbordo" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Carga_transbordo)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Tempo Transbordo</mat-label>
                                <input matInput id="txtTmpTransbordo" #txtTmpTransbordo maxlength="5" readonly
                                    formControlName="Tempo_transbordo" currencyMask class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                                </mat-hint>
                                <mat-hint align="end">{{txtTmpTransbordo.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Tempo_transbordo)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Saída do SDC para transbordo Data</mat-label>
                                <input matInput id="txtSaidaTransbordoData" #txtSaidaTransbordoData maxlength="10"
                                    mask="d0/M0/0000" formControlName="Saida_transbordo_data"
                                    [readonly]="readOnlyTransbordo" (blur)="getTempoTransbordo()"
                                    (blur)="makeCalculations()" [class.InputBlockColor]="readOnlyTransbordo">
                                <i matSuffix class="{{iconDisableField}}" *ngIf="readOnlyTransbordo"></i>
                                <i matSuffix class="{{iconEnableField}}" *ngIf="!readOnlyTransbordo"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintDate}}
                                </mat-hint>
                                <mat-hint align="end">{{txtSaidaTransbordoData.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Saida_transbordo_data)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Saída do SDC para transbordo Hora</mat-label>
                                <input matInput id="txtSaidaTransbordoHora" #txtSaidaTransbordoHora maxlength="5"
                                    mask="Hh:m0" formControlName="Saida_transbordo_hora" [readonly]="readOnlyTransbordo"
                                    (blur)="getTempoTransbordo()" (blur)="makeCalculations()"
                                    [class.InputBlockColor]="readOnlyTransbordo">
                                <i matSuffix class="{{iconDisableField}}" *ngIf="readOnlyTransbordo"></i>
                                <i matSuffix class="{{iconEnableField}}" *ngIf="!readOnlyTransbordo"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintHour}}
                                </mat-hint>
                                <mat-hint align="end">{{txtSaidaTransbordoHora.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Saida_transbordo_hora)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Reinício da Descarga do Transbordo Data</mat-label>
                                <input matInput id="txtReiDescargaTransbordoData" #txtReiDescargaTransbordoData
                                    maxlength="10" mask="d0/M0/0000" formControlName="Reinicio_descarga_transbordo_data"
                                    [readonly]="readOnlyTransbordo" (blur)="getTempoTransbordo()"
                                    (blur)="makeCalculations()" [class.InputBlockColor]="readOnlyTransbordo">
                                <i matSuffix class="{{iconDisableField}}" *ngIf="readOnlyTransbordo"></i>
                                <i matSuffix class="{{iconEnableField}}" *ngIf="!readOnlyTransbordo"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintDate}}
                                </mat-hint>
                                <mat-hint align="end">{{txtReiDescargaTransbordoData.value.length}} / 10</mat-hint>
                                <mat-error>
                                    {{hasErrorFormControl(formulario.controls.Reinicio_descarga_transbordo_data)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Reinício da Descarga do Transbordo Hora</mat-label>
                                <input matInput id="txtReiDescargaTransbordoHora" #txtReiDescargaTransbordoHora
                                    maxlength="5" mask="Hh:m0" formControlName="Reinicio_descarga_transbordo_hora"
                                    [readonly]="readOnlyTransbordo" (blur)="getTempoTransbordo()"
                                    (blur)="makeCalculations()" [class.InputBlockColor]="readOnlyTransbordo">
                                <i matSuffix class="{{iconDisableField}}" *ngIf="readOnlyTransbordo"></i>
                                <i matSuffix class="{{iconEnableField}}" *ngIf="!readOnlyTransbordo"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintHour}}
                                </mat-hint>
                                <mat-hint align="end">{{txtReiDescargaTransbordoHora.value.length}} / 5</mat-hint>
                                <mat-error>
                                    {{hasErrorFormControl(formulario.controls.Reinicio_descarga_transbordo_hora)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Término Descarga Data</mat-label>
                                <input matInput id="txtFimDescargaData" #txtFimDescargaData maxlength="10"
                                    [dropSpecialCharacters]="false" mask="d0/M0/0000"
                                    formControlName="Termino_descarga_data" (blur)="tonLaneHr()" (blur)="alertaData()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintDate}}
                                </mat-hint>
                                <mat-hint align="end">{{txtFimDescargaData.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Termino_descarga_data)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Término Descarga Hora</mat-label>
                                <input matInput id="txtFimDescargaHora" #txtFimDescargaHora maxlength="5" mask="Hh:m0"
                                    [dropSpecialCharacters]="false" formControlName="Termino_descarga_hora"
                                    (blur)="makeCalculations()" (blur)="tonLaneHr()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintHour}}
                                </mat-hint>
                                <mat-hint align="end">{{txtFimDescargaHora.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Termino_descarga_hora)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>



<div class="row" *ngIf="isPreBasica">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>

                <mat-card-content *ngIf="!collapseCard">
                    <!-- Criar component de adicionar varias caixa e peso tara - como pede o figma -->



                    <div class="row pt-3">
                        <div class="col-lg col-md col-xs col-sm col-xl text-right">
                            <button mat-flat-button color="primary" class="btnSize" matTooltip="Adicionar"
                                (click)="addItem()">
                                <i class="fa fa-plus fa-1x btnIcon"></i> Adicionar Caixa
                            </button>
                            <button mat-flat-button color="primary" class="btnSize" matTooltip="Remover"
                                (click)="removeItem()" [disabled]="disabledBtnRemove">
                                <i class="fa fa-minus fa-1x btnIcon"></i> Remover Caixa
                            </button>
                        </div>
                    </div>


                    <ng-template #viewContainerRef></ng-template>




                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>